import { useThemeTokens } from '../../../ThemeProvider';
import { useViewport } from '../../../ViewportProvider';

/**
 * Hook to get theme tokens for all viewports at once.
 * This is useful for components that need to support React Native Media Queries (RNMQ).
 *
 * All hooks are called unconditionally to comply with React's Rules of Hooks.
 *
 * @param {string} componentName - The name of the component to get tokens for
 * @param {object|function} tokens - Custom tokens or token function
 * @param {object} variant - Variant configuration
 * @returns {object} Object with tokens for each viewport (xs, sm, md, lg, xl, current)
 *
 * @example
 * const allTokens = useAllViewportTokens('StackView', tokens, variant)
 * // Returns: { xs: {...}, sm: {...}, md: {...}, lg: {...}, xl: {...}, current: {...} }
 */
const useAllViewportTokens = (componentName, tokens, variant) => {
  const viewport = useViewport();
  const xs = useThemeTokens(componentName, tokens, variant, {
    viewport: 'xs'
  });
  const sm = useThemeTokens(componentName, tokens, variant, {
    viewport: 'sm'
  });
  const md = useThemeTokens(componentName, tokens, variant, {
    viewport: 'md'
  });
  const lg = useThemeTokens(componentName, tokens, variant, {
    viewport: 'lg'
  });
  const xl = useThemeTokens(componentName, tokens, variant, {
    viewport: 'xl'
  });
  const current = useThemeTokens(componentName, tokens, variant, {
    viewport
  });
  return {
    xs,
    sm,
    md,
    lg,
    xl,
    current
  };
};
export default useAllViewportTokens;